import React from 'react'
import './button.css'

function ButtonOulined({name, onClickHandler, color="primary", size="small"}) {
  return (
    <button className={`btn outlined ${color} ${size}`} onClick={onClickHandler}>{name}</button>
  )
}

export default ButtonOulined